// POUR LA BARRE POLITIQUE DE CONFIDENTIALITE

try {

  var myDocument = document.getElementById("iframeStorage"); // on récupere l'iframe du storage.timothee.fr
  if (myDocument) {
    var iframeStorage = myDocument.contentWindow;
  }
} catch (error) {

}

// let packet = {
//   methode: "get",
// }
// iframeStorage.postMessage(packet, "https://storage.timothee.fr");

// let packet = {
//   methode: "post",
//   user: data.data,
//   authorities: authorities
// }
// iframeStorage.postMessage(packet, "https://storage.timothee.fr");

export const isAcceptCookies = () => {
  if (localStorage.getItem("cookies") === "true") {
    return true;
  } else {
    return false;
  }
};

export const acceptCookiesTrue = () => {
  localStorage.setItem("cookies", "true");
  let packet = {
    methode: "postCookies",
    cookies: "true"
  };
  if (iframeStorage) {

    iframeStorage.postMessage(packet, "https://storage.timothee.fr");
  }
};

export const getUserParsed = () => {
  //return JSON.parse(localStorage.getItem("user"));
  return JSON.parse(localStorage.getItem("user") || '{}');
};

export const setUserJson = userJson => {
  localStorage.setItem("user", userJson);
  let packet = {
    methode: "postUser",
    user: JSON.parse(userJson)
  };
  if (iframeStorage) {
    iframeStorage.postMessage(packet, "https://storage.timothee.fr");
  }
};

export const setAuthoritiesJson = authoritiesJson => {
  localStorage.setItem("authorities", authoritiesJson);
};

export const getAuthoritiesJson = () => {
  //return JSON.parse(localStorage.getItem("authorities"));
  return JSON.parse(localStorage.getItem("authorities") || '[]');
};

export const removeAuthorities = () => {
  localStorage.removeItem("authorities");
};

export const removeUser = () => {
  localStorage.removeItem("user");
  let packet = {
    methode: "removeUser"
  };
  if (iframeStorage) {
    iframeStorage.postMessage(packet, "https://storage.timothee.fr");
  }
};
